import en from './en.json';

/**
 * Minimal string lookup. Keys are dot paths into `en.json`; `{placeholders}` are
 * replaced from `params`. Strings live in JSON from day one so translation later
 * is a data task, not a refactor.
 *
 * A missing key returns the key itself and warns in development, so a typo is
 * visible on screen instead of rendering an empty element.
 */

type Params = Record<string, string | number>;

const dict = en as unknown as Record<string, unknown>;

function lookup(key: string): string | undefined {
  let node: unknown = dict;
  for (const part of key.split('.')) {
    if (typeof node !== 'object' || node === null) return undefined;
    node = (node as Record<string, unknown>)[part];
  }
  return typeof node === 'string' ? node : undefined;
}

export function t(key: string, params?: Params): string {
  const raw = lookup(key);
  if (raw === undefined) {
    if (import.meta.env.DEV) console.warn(`[i18n] missing string: ${key}`);
    return key;
  }
  if (!params) return raw;
  return raw.replace(/\{(\w+)\}/g, (match, name: string) =>
    name in params ? String(params[name]) : match,
  );
}

/** Every key in the bundle, used by the strings check script and by tests. */
export function allKeys(): string[] {
  const out: string[] = [];
  const walk = (node: unknown, prefix: string): void => {
    if (typeof node !== 'object' || node === null) return;
    for (const [k, v] of Object.entries(node)) {
      const path = prefix ? `${prefix}.${k}` : k;
      if (typeof v === 'string') out.push(path);
      else walk(v, path);
    }
  };
  walk(dict, '');
  return out.sort();
}
